export const ACTIVE_VALUE = "ACTIVE";
export const ALL_VALUE = "ALL";
export const INACTIVE_VALUE = "INACTIVE";
export const NO_VALUE = "NO_VALUE";
